<template>
    <header id="header" class="navbar navbar-sticky">
        <PrintCorpHeader v-if="hermesAPIConfig.client === 'imprimer-vos-livres'"
                         @show-forgot-password-modal="$emit('show-forgot-password-modal')"/>
        <ImprimBookHeader v-else-if="hermesAPIConfig.client === 'imprimbook'"
                         @show-forgot-password-modal="$emit('show-forgot-password-modal')"/>
        <DefaultHeader  v-else @show-forgot-password-modal="$emit('show-forgot-password-modal')"/>
    </header>
</template>

<script>
import { mapGetters } from "vuex";
import DefaultHeader from "@/components/Hermes/Header/DefaultHeader/DefaultHeader";
import PrintCorpHeader from "@/components/Hermes/Header/CustomHeader/PrintCorpHeader/PrintCorpHeader";
import ImprimBookHeader from "@/components/Hermes/Header/CustomHeader/ImprimBookHeader/ImprimBookHeader";

export default {
    name: "Header",
    components: {PrintCorpHeader, DefaultHeader, ImprimBookHeader},
    computed: {
        ...mapGetters("config", {
            hermesAPIConfig: "hermesAPI",
        }),
    },
};
</script>

<style scoped>
</style>